module.exports = __webpack_public_path__ + "media/bdaydance.70c9840f.mp3";